import React, { Component } from "react";
import {
    Paper,
    TableHead,
    Table,
    TableRow,
    Typography,
    TableCell,
    TableBody,
    Grid
} from "@material-ui/core";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import {
    getUsers,
    getReportTypes,
    setToDateFilter,
    setFromDateFilter
} from "./actions";

class ReportTotalDetail extends Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getReportTypes();
    }
    componentDidUpdate(nextProps, nextState) {
        if (nextProps.toDate !== this.props.toDate) {
            this.props.setToDateFilter(this.props.toDate);
        }
        if (nextProps.fromDate !== this.props.fromDate) {
            this.props.setFromDateFilter(this.props.fromDate);
        }
    }
    render() {
        const { reports, reportTypes, lg, md, sm } = this.props;

        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <Paper
                    style={{
                        paddingTop: 10,
                        height: "100%"
                    }}
                >
                    {" "}
                    <div style={{ width: "100%", overflow: "scroll" }}>
                        <Table style={{ marginTop: 20, marginBottom: 20 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCellHeader text="Total" />
                                    {reports &&
                                        Object.keys(reports).map((e, i) => {
                                            return (
                                                <TableCellHeader
                                                    key={i}
                                                    text={
                                                        reportTypes[
                                                            reports[e]
                                                                .reportType
                                                        ]
                                                    }
                                                />
                                            );
                                        })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reports && (
                                    <TableRow>
                                        <TableCellBody text={reports.total} />

                                        {Object.keys(reports).map((e, i) => {
                                            return (
                                                <TableCellBody
                                                    key={i}
                                                    text={
                                                        reports[e].reportTotal
                                                    }
                                                />
                                            );
                                        })}
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </Paper>
            </Grid>
        );
    }
}

const TableCellHeader = props => {
    return (
        <TableCell style={{ textAlign: "center" }}>
            <Typography variant="body2">
                <b>{props.text}</b>
            </Typography>
        </TableCell>
    );
};
const TableCellBody = props => {
    return (
        <TableCell style={{ textAlign: "center" }}>
            <Typography variant="body2">{props.text}</Typography>
        </TableCell>
    );
};
export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const { selectReports, selectReportTypes } = selectors;
            return {
                reports: selectReports(store),
                reportTypes: selectReportTypes(store)
            };
        },
        { getUsers, getReportTypes, setToDateFilter, setFromDateFilter }
    )(ReportTotalDetail)
);
